import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoadingUI from "./components/desktop/common/LoadingUI";
import ScrollToTop from "./utils/ScrollToTop";
import useDeviceType from "./utils/useDeviceType";
import { setVh } from "./utils/setVh";
import { BASENAME, DEV_ENTRY_PATH_REGEX } from "@/constants/event";
// import GoogleTagManager from "./utils/GoogleTagManager";
// import useGtmPageView from "./utils/useGtmPageView";

const MainLayout = lazy(() => import("@/layouts/MainLayout"));
const HomeLayout = lazy(() => import("@/layouts/HomeLayout"));
const TracksLayout = lazy(() => import("@/layouts/TracksLayout"));
const EventLayout = lazy(() => import("@/layouts/EventLayout"));
const FaqLayout = lazy(() => import("@/layouts/FaqLayout"));
const PreviousLayout = lazy(() => import("@/layouts/PreviousLayout"));
const RegisterLayout = lazy(() => import("@/layouts/RegisterLayout"));
const NotFound = lazy(() => import("@/layouts/NotFoundLayout"));

// 개발/운영 공통 스위치
// true: 개발 접근 제어 활성화 + TEST API 사용
// false: 개발 접근 제어 비활성화 + OFFICIAL API 사용
export const isDevMode = false;

function App() {
  // 디바이스 타입과 viewport 높이를 전역 UI 기준으로 동기화
  useDeviceType();
  // useGtmPageView();

  // 개발 버전 접근 제어 플래그
  const currentUrl = new URL(window.location.href);
  const isTargetHost = /(^|\.)squp\.kr$/i.test(currentUrl.hostname);
  const isDevEntryPath = DEV_ENTRY_PATH_REGEX.test(currentUrl.pathname);
  const isDevQuery = currentUrl.searchParams.get("mode") === "dev";
  const shouldRestrictDevAccess = isDevMode && isTargetHost;
  const isDevAccessAllowed =
    !shouldRestrictDevAccess || (isDevEntryPath && isDevQuery);

  useEffect(() => {
    setVh();
    window.addEventListener("resize", setVh);
    return () => window.removeEventListener("resize", setVh);
  }, []);

  useEffect(() => {
    if (!isDevAccessAllowed) {
      window.location.replace("https://squp.kr");
    }
  }, [isDevAccessAllowed]);

  if (!isDevAccessAllowed) {
    return null;
  }

  const isSamsungBrowser = /SamsungBrowser/i.test(navigator.userAgent);
  if (isSamsungBrowser) {
    alert(
      "삼성 브라우저에서 자동 다크모드가 적용되어 색상이 왜곡될 수 있습니다. \n Chrome 등 다른 브라우저 사용을 권장합니다.",
    );
  }

  return (
    <>
      {/* <GoogleTagManager gtmId="GTM-KK24G4XW" /> */}
      <BrowserRouter basename={BASENAME}>
        <ScrollToTop />
        {/* <LoadingUI /> */}
        <Suspense fallback={<LoadingUI />}>
          {/* 페이지별 레이아웃 라우팅 */}
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<HomeLayout />} />
              {/* <Route path="/about" element={<AboutLayout title="ABOUT" />} /> */}
              <Route path="/tracks" element={<TracksLayout title="TRACKS" />} />
              <Route path="/event" element={<EventLayout title="EVENT" />} />
              <Route path="/faq" element={<FaqLayout title="FAQ" />} />
              <Route
                path="/previous"
                element={<PreviousLayout title="PREVIOUS" />}
              />
              <Route
                path="/register"
                element={<RegisterLayout title="REGISTER" />}
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
